import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { FormElement } from "../types";

interface SwitchInputProps {
  element: FormElement;
  value: string;
  onChange: (value: string) => void;
}

export const SwitchInput = ({ element, value, onChange }: SwitchInputProps) => {
  return (
    <div className="flex items-center space-x-2">
      <Switch
        id={element.id}
        checked={value === "true"}
        onCheckedChange={(checked) => onChange(checked ? "true" : "false")}
      />
      <Label htmlFor={element.id}>
        {element.title}
        {element.required && <span className="text-red-500 ml-1">*</span>}
      </Label>
    </div>
  );
};